import React from 'react';
import { ScanStatusBadge } from './ScanStatusBadge';
import { TrashIcon } from './StatusIcons';
import { UiMessages } from '../uiMessages';

export function UploadItemCard({
  item,
  mediaSizeText,
  interactionLocked,
  isUploadBlockedByCaseStatus,
  transcriptAccept,
  presentation,
  onDescriptionChange,
  onMediaDelete,
  onTranscriptToggle,
  onTranscriptFileChange,
  onBrowseTranscript,
  onTranscriptDescriptionChange,
  onTranscriptDelete,
  setTranscriptInputRef
}) {
  const {
    isRejectedRow,
    mediaTone,
    transcriptTone,
    mediaDeleteButtonStyle,
    transcriptDeleteButtonStyle
  } = presentation;

  return (
    <div className={`upload-item-card ${isRejectedRow ? 'upload-item-card-virus' : ''}`}>
      <div className="uploaded-file-row">
        <div className="file-main-content">
          <div className="file-top-row">
            <div className="file-heading-row">
              <div className="file-heading-content">
                <div className="file-name-truncate file-title">{item.mediaFile.name}</div>
                <div className="file-subtitle">{mediaSizeText}</div>
                <ScanStatusBadge tone={mediaTone} />
              </div>
            </div>

            <div className="file-inline-actions">
              {item.mediaUploadStatus === 'uploading' ? (
                <div className="upload-spinner" aria-label="Uploading" />
              ) : (
                <input
                  type="text"
                  className="description-input"
                  placeholder="Description (optional)"
                  value={item.description}
                  disabled={interactionLocked}
                  onChange={(event) => onDescriptionChange(item.id, event.target.value)}
                />
              )}
              {!isUploadBlockedByCaseStatus ? (
                <button
                  className="icon-action-button file-delete-button"
                  type="button"
                  disabled={interactionLocked}
                  style={mediaDeleteButtonStyle}
                  onClick={() => onMediaDelete(item.id)}
                  aria-label={`Remove media file ${item.mediaFile.name}`}
                >
                  <TrashIcon />
                </button>
              ) : null}
            </div>
          </div>

          <div className="transcript-section">
            {!item.transcriptEnabled ? (
              <label className="transcript-inline-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={item.transcriptEnabled}
                  disabled={interactionLocked || isUploadBlockedByCaseStatus}
                  onChange={(event) => onTranscriptToggle(item.id, event)}
                />
                <span>{UiMessages.transcriptIncluded}</span>
              </label>
            ) : null}

            {item.transcriptEnabled ? (
              <div className="transcript-upload-row">
                <input
                  ref={setTranscriptInputRef}
                  type="file"
                  className="d-none"
                  accept={transcriptAccept}
                  disabled={interactionLocked || isUploadBlockedByCaseStatus}
                  onChange={(event) => onTranscriptFileChange(item.id, event)}
                />

                <div className="file-heading-row transcript-file-body">
                  <div className="file-heading-content">
                    <div className="transcript-file-name-row">
                      {item.transcriptFile ? (
                        <div className="file-name-truncate transcript-file-name">{item.transcriptFile.name}</div>
                      ) : (
                        <button
                          type="button"
                          className="browse-button transcript-browse-button"
                          disabled={interactionLocked || isUploadBlockedByCaseStatus}
                          onClick={onBrowseTranscript}
                        >
                          Browse transcript
                        </button>
                      )}
                    </div>
                    {item.transcriptFile ? (
                      <ScanStatusBadge tone={transcriptTone} />
                    ) : null}
                  </div>
                </div>

                <div className="file-inline-actions transcript-file-inline-actions">
                  {item.transcriptUploadStatus === 'uploading' ? (
                    <div className="upload-spinner" aria-label="Uploading" />
                  ) : item.transcriptFile ? (
                    <input
                      type="text"
                      className="description-input"
                      placeholder="Description (optional)"
                      value={item.transcriptDescription}
                      disabled={interactionLocked}
                      onChange={(event) => onTranscriptDescriptionChange(item.id, event.target.value)}
                    />
                  ) : (
                    <div className="file-inline-progress" aria-hidden="true" />
                  )}
                  {!isUploadBlockedByCaseStatus ? (
                    <button
                      className="icon-action-button file-delete-button"
                      type="button"
                      disabled={interactionLocked}
                      style={transcriptDeleteButtonStyle}
                      aria-label={item.transcriptFile ? `Remove transcript file ${item.transcriptFile.name}` : 'Remove transcript'}
                      onClick={() => onTranscriptDelete(item)}
                    >
                      <TrashIcon />
                    </button>
                  ) : null}
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
